import tinycolor from 'tinycolor2'

export const mostReadable = color => tinycolor.mostReadable(color, [
  '#000', '#333', '#666', '#999', '#ccc', '#fff'
], { includeFallbackColors: true }).toHexString()

export const darken = color => tinycolor(color).darken(10).toString()
